import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TokenGuard} from './core/guards/token.guard';

const routes: Routes = [
    {path: '', redirectTo: 'auth/signin', pathMatch: 'full'},
    {
        path: 'auth',
        loadChildren: () =>
            import('./pages/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'profile',
        loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfileModule),
        canActivate: [TokenGuard]
    },
    {
        path: 'deliveries',
        loadChildren: () => import('./pages/deliveries/deliveries.module').then((m) => m.DeliveriesModule),
        canActivate: [TokenGuard]
    },
    {
        path: 'reports',
        loadChildren: () => import('./pages/reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [TokenGuard]
    },
    {
        path: 'configurations',
        loadChildren: () => import('./pages/configurations/configurations.module').then((m) => m.ConfigurationsModule),
        canActivate: [TokenGuard]
    },
    {
        path: 'api',
        loadChildren: () => import('./pages/api/api.module').then((m) => m.ApiModule),
        canActivate: [TokenGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            useHash: false,
            scrollPositionRestoration: 'enabled',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
